exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-link[data-v-361bf7cf] {\n  display: block;\n  height: 150px;\n}\n.img[data-v-361bf7cf] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.watermarked[data-v-361bf7cf]:after {\n  background-image: none !important;\n}\n", ""]);

// exports
